import { getDraftForUser, deleteDraft } from '@/services/uploadDraftService'
import { getDraftUploads } from '@/services/jobsService'

function deslugify (slug) {
  return slug.split('-').filter(Boolean).map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join(' ')
}

export default {
  namespaced: true,
  state: function () {
    return {
      summary: null
    }
  },
  getters: {
    HAS_DRAFT: function (state) { return !!state.summary },
    SUMMARY: function (state) { return state.summary }
  },
  mutations: {
    SET_SUMMARY: function (state, summary) { state.summary = summary }
  },
  actions: {
    REFRESH_SUMMARY: function (context) {
      var email = context.rootState.user && context.rootState.user.email
      if (!email) {
        context.commit('SET_SUMMARY', null)
        return Promise.resolve()
      }
      return getDraftForUser(email).then(function (localSummary) {
        if (localSummary) {
          context.commit('SET_SUMMARY', Object.assign({ source: 'local' }, localSummary))
          return
        }
        // No draft on this device — check the server for files uploaded elsewhere
        // (or in a session that expired before the final submit) that never made
        // it into a job, so the user can still resume from here.
        return getDraftUploads().then(function (serverDrafts) {
          if (!serverDrafts || !serverDrafts.length) {
            context.commit('SET_SUMMARY', null)
            return
          }
          var draft = serverDrafts[0]
          context.commit('SET_SUMMARY', {
            source: 'server',
            projectSlug: draft.projectSlug,
            projectName: draft.projectName || deslugify(draft.projectSlug),
            totalFiles: draft.files.length,
            doneFiles: draft.files.length,
            updatedAt: draft.updatedAt
          })
        })
      }).catch(function () { context.commit('SET_SUMMARY', null) })
    },
    DISCARD: function (context) {
      var summary = context.state.summary
      if (!summary) return Promise.resolve()
      if (summary.source === 'server') {
        // Nothing to delete server-side here — the nightly StorageCleanupService
        // sweep reclaims orphaned uploads on its own schedule. This just dismisses
        // the banner locally.
        context.commit('SET_SUMMARY', null)
        return Promise.resolve()
      }
      return deleteDraft(summary.draftId).then(function () {
        context.commit('SET_SUMMARY', null)
      })
    }
  }
}
